/*
  assets/bam-search.js — shared matching core for every BAM search box.

  Loaded with <script src="{{ 'bam-search.js' | asset_url }}" defer></script> from any
  section that searches Field Notes content. Same pattern as metaobject-gallery.js.

  WHY IT EXISTS: the stemmer and the synonym map used to be copy-pasted into both
  sections/featured-blog-posts.liquid and sections/wallpaper-library.liquid. Two copies
  meant the same word could find different things on two pages the moment one drifted.
  This is the single source of truth. Edit here, nowhere else.

  MATCHING RULES (BAM's calls, do not quietly change):
   - Substring ANYWHERE in a word, so "creeper" finds Honeycreeper and Woodcreeper.
     The cost is mid-word coincidences like "deer" matching Killdeer. Judged acceptable.
   - A conservative stemmer only (-ies/-es/-s). Aggressive stemming causes false matches.
   - A synonym is ADDITIVE: the typed word is tried AS WELL AS its synonym, so an entry
     can only ever ADD results. An earlier REPLACING version silently destroyed results
     (flower killed the Flowerpiercers, mountain killed Mountain Toucan).
   - Recall over precision is the standing principle.
*/
(function () {
  if (window.BAMSearch) return;

  var SYNONYMS = {
    /* original set */
    bunny: 'rabbit', toadstool: 'mushroom', buck: 'deer', doe: 'deer', fawn: 'deer',
    hummer: 'hummingbird', seagull: 'gull', seastar: 'starfish',
    /* irregular plurals and forms the stemmer cannot reach */
    geese: 'goose', gosling: 'goose', fungus: 'fungi', fungi: 'mushroom', mushroom: 'fungi',
    /* other names for animals that really are in the library */
    stag: 'deer', wapiti: 'elk', hare: 'rabbit', jackrabbit: 'rabbit', salamander: 'newt',
    tadpole: 'frog', toad: 'frog', coypu: 'nutria', weasel: 'tayra', alpaca: 'llama',
    falcon: 'caracara', buzzard: 'hawk', ladybug: 'beetle', colibri: 'hummingbird',
    moth: 'butterfly', snail: 'slug', dove: 'pigeon', wasp: 'bee', hornet: 'bee',
    /* the general word, when the titles all use a specific one */
    bug: 'insect', rodent: ['squirrel', 'chipmunk', 'nutria', 'agouti', 'pika'],
    waterfowl: ['duck', 'goose'], duckling: 'duck', lichen: 'oakmoss',
    flower: 'plant', wildflower: 'plant', tree: ['maple', 'forest'], web: 'spider',
    /* landscape words */
    volcano: 'mt', mountain: 'mt', peak: 'mt', summit: 'mt',
    ocean: 'sea', coast: 'beach', creek: 'river', stream: 'river',
    winter: 'snow', night: 'moon', sunrise: 'sunset'
  };

  function stem(w) {
    if (w.length > 4 && w.slice(-3) === 'ies') return w.slice(0, -3) + 'y';
    if (w.length > 5 && (w.slice(-4) === 'ches' || w.slice(-4) === 'shes')) return w.slice(0, -2);
    if (w.length > 4 && (w.slice(-3) === 'ses' || w.slice(-3) === 'xes' || w.slice(-3) === 'zes')) return w.slice(0, -2);
    if (w.length > 3 && w.slice(-1) === 's' && w.slice(-2) !== 'ss') return w.slice(0, -1);
    return w;
  }

  /* Each query word becomes a LIST of acceptable forms: the word itself, then synonyms. */
  function tokenize(q) {
    return q.toLowerCase().split(/[^a-z0-9]+/).filter(Boolean).map(function (w) {
      var syn = SYNONYMS[w] || SYNONYMS[stem(w)];
      var alts = [w];
      if (syn) alts = alts.concat(typeof syn === 'string' ? [syn] : syn);
      return alts.map(function (s) { return { raw: s, stem: stem(s) }; });
    });
  }

  /* Annotate an article with the haystacks the matcher needs: a._raw / a._words. */
  function annotate(a) {
    var hay = (a.title + ' ' + ((a.tags || []).join(' '))).toLowerCase();
    a._raw = hay.split(/[^a-z0-9]+/).filter(Boolean);
    a._words = a._raw.map(stem);
    return a;
  }

  /* Every query word must hit the title or a tag, by substring or by stem. */
  function matches(a, tokens) {
    for (var i = 0; i < tokens.length; i++) {
      var alts = tokens[i], hit = false, k, j;
      for (k = 0; k < alts.length && !hit; k++) {
        for (j = 0; j < a._raw.length; j++) {
          if (a._raw[j].indexOf(alts[k].raw) !== -1) { hit = true; break; }
        }
        if (!hit) for (j = 0; j < a._words.length; j++) {
          if (a._words[j] === alts[k].stem) { hit = true; break; }
        }
      }
      if (!hit) return false;
    }
    return true;
  }

  window.BAMSearch = { SYNONYMS: SYNONYMS, stem: stem, tokenize: tokenize, annotate: annotate, matches: matches };
})();
